import { api } from "../lib";

export interface LoginRequest {
  username: string;
  password: string;
}

export interface PermittedTask {
  id: string;
  name: string;
  slug: string;
  displayOrder: number;
}

export interface UserGroupProfile {
  id: string;
  name: string;
}

export interface LoginResponse {
  token: string;
  mustChangePassword: boolean;
  user: {
    id: string;
    username: string;
    email: string;
    fullName: string;
    roleId: string | null;
    roleName?: string;
    groups?: UserGroupProfile[];
    groupId: string | null;
    groupName?: string;
    facilityId: string | null;
    facilityName?: string;
    isActive: boolean;
    isRemote: boolean;
    permittedTasks?: PermittedTask[];
    roleTaskIds?: string[];
    savedTaskIds?: string[] | null;
    permissions?: string[];
  };
}

export interface CurrentUserResponse {
  id: string;
  username: string;
  email: string;
  fullName: string;
  roleId: string | null;
  roleName?: string;
  groups?: UserGroupProfile[];
  groupId: string | null;
  groupName?: string;
  facilityId: string | null;
  facilityName?: string;
  isActive: boolean;
  isRemote: boolean;
  permittedTasks?: PermittedTask[];
  roleTaskIds?: string[];
  savedTaskIds?: string[] | null;
  permissions?: string[];
}

export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

export const authService = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    return api.post<LoginResponse>("/auth/login", data);
  },

  getCurrentUser: async (): Promise<CurrentUserResponse> => {
    return api.get<CurrentUserResponse>("/auth/me");
  },

  changePassword: async (
    data: ChangePasswordRequest
  ): Promise<{ message: string }> => {
    return api.post<{ message: string }>("/auth/change-password", data);
  },

  forgotPassword: async (
    data: ForgotPasswordRequest
  ): Promise<{ message: string }> => {
    return api.post<{ message: string }>("/auth/forgot-password", data);
  },

  getResetTokenInfo: async (
    token: string
  ): Promise<{
    fullName: string;
    username: string;
    invitationStatus: string;
    roleName: string | null;
    facilityName: string | null;
    invitedByName: string | null;
    invitedByEmail: string | null;
    portalUrl: string;
  }> => {
    return api.get(`/auth/reset-token-info?token=${encodeURIComponent(token)}`);
  },

  resetPassword: async (
    data: ResetPasswordRequest
  ): Promise<{ message: string }> => {
    return api.post<{ message: string }>("/auth/reset-password", data);
  },

  sendInvitation: async (userId: string): Promise<{ message: string }> => {
    return api.post<{ message: string }>(`/auth/send-invitation/${userId}`);
  },
};
